import { Children, ReactNode } from 'react';

/** ラベル + 値の 1 行。値が空(undefined/null/'')なら何も描画しない。 */
export const Row = (props: { label: string, value?: string | number | null }) => {
  const v = props.value;
  if (v === undefined || v === null || v === '') return null;
  return (
    <div className="top_label_ui order_category__item order_detail_confirm_view__row">
      <div className="top_label_ui__label">{props.label}</div>
      <div className="order_detail_confirm_view__value">{String(v)}</div>
    </div>
  );
};

/** ラベル + 複数値(半角スペース区切り)の 1 行。空値(undefined/null/'')は除外し、全て空なら描画しない。 */
export const RowMulti = (props: { label: string, values?: (string | undefined | null)[] }) => {
  const vs = (props.values || []).filter((v): v is string => Boolean(v));
  if (!vs.length) return null;
  return (
    <div className="top_label_ui order_category__item order_detail_confirm_view__row">
      <div className="top_label_ui__label">{props.label}</div>
      <div className="order_detail_confirm_view__value">{vs.join(' ')}</div>
    </div>
  );
};

/**
 * 見出し + 子要素のセクション。
 * 表示される子(Row/RowMulti が null を返さなかったもの)が 1 つも無ければ見出しごと非表示にする。
 * ※ Row/RowMulti は JSX 要素ではなく関数呼び出しで渡すこと({Row({...})})。
 *   <Row /> で渡すと「中身が空でも要素は存在する」ため空判定が効かない。
 */
export const Section = (props: { title: string, children: ReactNode }) => {
  const childArray = Children.toArray(props.children).filter(Boolean);
  if (!childArray.length) return null;
  return (
    <div className="order_category">
      <div className="bottom_border_header order_category__header">{props.title}</div>
      {childArray}
    </div>
  );
};
